/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * ShopifyOrderImportOrderResultDtoBase
 * auto generated base class for the model ShopifyOrderImportOrderResultDtoModel.
 */
export const ShopifyOrderImportOrderResultDtoModelBase = ModelBase
  .named('ShopifyOrderImportOrderResultDto')
  .props({
    __typename: types.optional(types.literal("ShopifyOrderImportOrderResultDto"), "ShopifyOrderImportOrderResultDto"),
    shopifyOrderId: types.union(types.undefined, types.string),
    orderName: types.union(types.undefined, types.null, types.string),
    status: types.union(types.undefined, types.string),
    reason: types.union(types.undefined, types.null, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ShopifyOrderImportOrderResultDtoModelSelector extends QueryBuilder {
  get shopifyOrderId() { return this.__attr(`shopifyOrderId`) }
  get orderName() { return this.__attr(`orderName`) }
  get status() { return this.__attr(`status`) }
  get reason() { return this.__attr(`reason`) }
}
export function selectFromShopifyOrderImportOrderResultDto() {
  return new ShopifyOrderImportOrderResultDtoModelSelector()
}

export const shopifyOrderImportOrderResultDtoModelPrimitives = selectFromShopifyOrderImportOrderResultDto().shopifyOrderId.orderName.status.reason
